import { ReactElement } from 'react';
import './index.less';

type TAvatarProps = {
  size?: number;
  children?: ReactElement | string;
  imgSrc?: string;
  bgColor?: string;
  textColor?: string;
  fontSize?: string;
  shape?: 'circle' | 'square';
  alt?: string;
  className?: string;
};

const FONT_SIZE_COEF = 2.5;

export const Avatar = ({
  size,
  children,
  imgSrc,
  bgColor,
  textColor,
  fontSize,
  shape,
  alt,
  className
}: TAvatarProps) => {
  const computedFontSize =
    fontSize || (size ? `${size / FONT_SIZE_COEF}px` : '14px');

  return imgSrc ? (
    <img
      src={imgSrc}
      alt={alt}
      className={`avatar ${className ? className : ''}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: shape === 'circle' ? '50%' : '8px',
        objectFit: 'cover'
      }}
    />
  ) : (
    <div
      role="img"
      aria-label={alt}
      className={`avatar ${className ? className : ''}`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: bgColor,
        color: textColor,
        fontSize: computedFontSize,
        borderRadius: shape === 'square' ? '8px' : '50%'
      }}
    >
      {children}
    </div>
  );
};
